import * as actions from '../utils/Constants';
import Routes from '../utils/Routes';

import { apiRequest, apiGet, apiDeleteWithBodyAndThen, apiPostAndThen, Methods } from '../utils/Api';

export const updateTraining = (training) => {
    return dispatch => dispatch({
        type: actions.UPDATE_TRAINING,
        payload: apiRequest(Routes.training, Methods.post, training, dispatch)
    });
};

export const setField = (field, value) => ({
    type: actions.SET_TRAINING_FIELD,
    field,
    payload: value
});

export const setTrainingLocation = (currentSessionId, field, value) => ({
    type: actions.SET_TRAINING_LOCATION,
    currentSessionId,
    field,
    payload: value
});


export const setLocationField = (field, value) => ({
    type: actions.SET_TRAINING_LOCATION_FIELD,
    field,
    payload: value
});

export const addTrainingPersonnel = (trainingId, personnelType, persons) => ({
    type: actions.ADD_TRAINING_PERSONNEL,
    payload: persons,
    trainingId,
    personnelType
});

export const updateTrainingPrograms = (programIds) => {
    return {
        type: actions.UPDATE_TRAINING_PROGRAMS,
        payload: programIds
    }
}

export const deleteTrainingPersonnel = (ids) => ({
    type: actions.DELETE_TRAINING_PERSONNEL,
    payload: ids
});

export const getTrainingDocuments = (trainingId) => ({
    type: actions.GET_TRAINING_DOCUMENTS,
    payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/documents`)
});

export const addTrainingDocument = (trainingId, type, files) => {
    const data = new FormData();
    files.forEach(file => data.append('files', file, file.fileName));

    return {
        type: actions.ADD_TRAINING_DOCUMENT,
        payload: fetch(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/document/${type}`, {
            method: 'POST',
            credentials: 'include',
            body: data
        }).then(res => {
            return res.json();
        })
    }
}

export const deleteTrainingDocument = (trainingId, trainingDocumentIds = []) => ({
    type: actions.DELETE_TRAINING_DOCUMENT,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/training/documents`, trainingDocumentIds, () =>
        apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/documents`))
});

const getTrainingJournalApi = (trainingId) => apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/journal`)

export const saveTrainingJournalEntry = (trainingId, journalEntry) => ({
    type: actions.ADD_UPDATE_TRAINING_JOUNALENTRY,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/training/journal`, journalEntry, () => getTrainingJournalApi(trainingId))
});

export const getTrainingJournal = (trainingId) => ({
    type: actions.GET_TRAINING_JOURNAL,
    payload: getTrainingJournalApi(trainingId)
});

export const deleteTrainingJournalEntries = (trainingId, ids) => ({
    type: actions.DELETE_TRAINING_JOUNALENTRIES,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/training/journal`, ids, () => getTrainingJournalApi(trainingId))
});

export const getTrainingFaculty = (trainingId) => ({
    type: actions.GET_TRAINING_FACULTY,
    payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/faculty`)
});

export const addTrainingFaculty = (trainingId, personIds) => ({
    type: actions.ADD_TRAINING_FACULTY,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/faculty`, personIds, () => apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/faculty`))
});

export const deleteTrainingFaculty = (trainingId, personIds) => ({
    type: actions.DELETE_TRAINING_FACULTY,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/faculty`, personIds, () => apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/faculty`))
});

export const getTrainingCurriulum = (trainingId) => ({
    type: actions.GET_TRAINING_CURRICULUM,
    payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/curriculum`)
});

export const addTrainingCurriculum = (trainingId, courseIds, addSections) => {
    return dispatch => dispatch({
        type: actions.ADD_TRAINING_CURRICULUM,
        payload: apiRequest(
            addSections ? `${process.env.REACT_APP_API_HOST}api/training/${trainingId}/sections/`
                : `${process.env.REACT_APP_API_HOST}api/training/${trainingId}/courses/`,
            Methods.post,
            courseIds,
            dispatch
        )
    })
};

export const deleteTrainingCurriculum = (trainingId, courseIds) => ({
    type: actions.DELETE_TRAINING_CURRICULUM,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/curriculum`, courseIds, () => apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/curriculum`))
});

export const addTrainingPrograms = (trainingId, programIds) => {
    return dispatch => {
        apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/programs`, Methods.post, programIds, dispatch).then(() => {
            dispatch(getTrainingContacts(trainingId));
            dispatch(getTrainingPrograms(trainingId));
        })
    };
}

export const deleteTrainingPrograms = (trainingId, programIds) => {
    return dispatch => {
        apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/programs`, Methods.delete, programIds, dispatch).then(() => {
            dispatch(getTrainingContacts(trainingId));
            dispatch(getTrainingPrograms(trainingId));
        })
    };
}

export const getTrainingContacts = (trainingId) => ({
    type: actions.GET_TRAINING_CONTACTS,
    payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/contacts`)
});

export const getTrainingPrograms = (trainingId) => ({
    type: actions.GET_TRAINING_PROGRAMS,
    payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/programs`)
});

export const addCourseFaculty = (course, person) => {
    return {
        type: actions.ADD_COURSE_FACULTY,
        payload: { course, person }
    }
}

export const removeCourseFaculty = (course, person) => {
    return {
        type: actions.REMOVE_COURSE_FACULTY,
        payload: { course, person }
    }
}

export const saveTrainingCourseAssignments = (trainingId, curriculum) => ({
    type: actions.ADD_TRAINING_CURRICULUM,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/curriculum/courseAssignments`, curriculum, () => apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/curriculum`))
});

export const addTrainingContact = (trainingId, contact) => {
    return dispatch => dispatch({
        type: actions.ADD_TRAINING_CONTACT,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/contact`, Methods.post, contact, dispatch)
    });
};

export const clearTrainingContactSearch = () => {
    return {
        type: actions.CLEAR_TRAINING_CONTACTS_SEARCH
    }
}

export const addTrainingContacts = (trainingId, contacts) => {
    return dispatch => dispatch({
        type: actions.ADD_TRAINING_CONTACT,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/contacts`, Methods.post, contacts, dispatch)
    });
};

export const deleteTrainingContacts = (trainingId, ids) => {
    return dispatch => dispatch({
        type: actions.DELETE_TRAINING_CONTACT,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/contacts`, Methods.delete, ids, dispatch)
    });
};

export const updateTrainingDocument = (trainingId, trainingDocumentId, documentTypeId) => {
    return dispatch => {
        apiRequest(`${process.env.REACT_APP_API_HOST}api/training/document/${trainingDocumentId}`, Methods.put, documentTypeId, dispatch).then(() => {
            dispatch(getTrainingDocuments(trainingId));
        })
    };
};

export const searchContacts = (trainingId, searchTerm) => ({
    type: actions.SEARCH_PERSONS,
    payload: searchTerm ? apiRequest(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/contactsearch`, Methods.post, searchTerm) : []
});